module.exports = __webpack_public_path__ + "static/flying-black-eye-susan_acrylic-on-paper-16x20in-6c5ff193fc63d89c45696fbd3de542db.jpg";